import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../axiosInstance";
import { AuthContext } from "../context/AuthContext";
import {
  Container,
  Typography,
  TextField,
  Button,
  Stack,
  Paper,
} from "@mui/material";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setAuthData } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await axiosInstance.post("/api/auth/login", {
        email,
        password,
      });

      console.log("Login.js: handleLogin(): response = ", response);
      setAuthData({ token: response.data.accessToken, email }); // Store JWT token and email in context
      console.log("Login.js: navigate('/meal-planner')");
      navigate("/meal-planner"); // Redirect to the main page
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Invalid credentials. Please try again.";
      if (errorMsg.includes("confirm your email")) {
        setError(
          "Please confirm your email before logging in. Check your inbox for a confirmation link or resend the email if necessary."
        );
      } else {
        setError(errorMsg);
      }
    }
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ padding: 4, mt: 8 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Login
        </Typography>
        {error && (
          <Typography color="error" align="center">
            {error}
          </Typography>
        )}
        <Stack spacing={2}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogin}
            fullWidth
          >
            Login
          </Button>
          <Button
            variant="text"
            color="secondary"
            onClick={() => navigate("/signup")} // Redirect to the signup page
            fullWidth
          >
            Don't have an account? Sign Up
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default Login;
